export enum SubscriptionPaymentMethod {
  // Sepa transfer issued by the buyer
  SEPA = 'SEPA',
  // Queued payment, can execute a credit transfer after being triggered
  QUEUED_CREDIT_TRANSFER = 'QUEUED_CREDIT_TRANSFER',
  // Credit transfer executed on a given date
  SCHEDULED_CREDIT_TRANSFER = 'SCHEDULED_CREDIT_TRANSFER',
}
